import state from './state'
import actions from './actions'
import mutations from './mutations'

import { make } from 'vuex-pathify'

export default {
  namespaced: true,
  getters: {
    ...make.getters(state)
  },
  mutations: {
    ...make.mutations(state),
    ...mutations
  },
  actions,
  state
}
